import React from 'react';
import styles from './StudentCourseTotalWidget.module.css';
import MLButton from '../../../components/MLButton';

const StudentCourseTotalWidget = ({ data, onViewClick }) => {
  const lowScoringStudentCount = data?.lowScoringStudentCount ?? 0;
  const formattedStudents =
    lowScoringStudentCount === 1 ? 'student' : 'students';

  return (
    <div
      className={styles.container}
      data-test-id="course_total_summary_container"
    >
      <div className={styles.title} data-test-id="course_total_title">
        Students to Review
      </div>
      <div className={styles.studentCount}>
        {lowScoringStudentCount} {formattedStudents}
      </div>
      <div className={styles.description}>
        Have a course total below 60% in the previous week
      </div>
      <div className={styles.viewDetailsBtnContainer}>
        <MLButton
          className={styles.viewDetailsBtn}
          onClick={onViewClick}
          btnType="secondary"
          btnText="View Course Totals"
          testId="course_total_alert_view_totals_btn"
        />
      </div>
    </div>
  );
};

export default StudentCourseTotalWidget;
